import Link from "next/link";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

export default ({ items = [] }) => (
  <div className="container">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-0 flex-nowrap  text-truncate">
        <li className="breadcrumb-item col-auto">
          <Link href="/">
            <a href="/">Home</a>
          </Link>
        </li>
        {items.map((x) => (
          <li className="breadcrumb-item col-auto">
            <span>
              <MdOutlineKeyboardArrowRight />
            </span>
            {!x?.href ? (
              <a>{x?.label}</a>
            ) : (
              <Link href={x.href}>
                <a href={x.href}>{x.label}</a>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  </div>
);
